import React from "react";
import { useParams } from "react-router";
import { EditPage } from "../../../blocks/blog-edit/EditPage";

export const BlogEditPage = () => {
  const { id } = useParams();

  return <EditPage isEdit id={id} />;
};
